import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Info = ({ title, description, rules, giftedBy }) => {
  return (
    <Fragment>
      <Heading size="tera">
        <strong>Cupom Compartilhável</strong> <br />
        {title}
      </Heading>

      {giftedBy && <S.TextShare>{giftedBy}</S.TextShare>}

      {description && (
        <Fragment>
          <S.Description heading>Descrição</S.Description>
          <S.Description>{description}</S.Description>
        </Fragment>
      )}

      {rules && (
        <Fragment>
          <S.Description heading>Regras de Utilização</S.Description>
          <S.Description>{rules}</S.Description>
        </Fragment>
      )}
    </Fragment>
  )
}

Info.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  rules: PropTypes.string,
  giftedBy: PropTypes.string
}

export default Info
